<template>
  <div v-if="!getVideo" class="flex flex-wrap">
    <div class="w-3/4" @click="goToHome()">
      <img :src="logo" alt="educational logo" class="w-32" />
    </div>

    <div class="w-1/4 p-2">
      <UtilityComponent />
    </div>

    <div class="w-full px-3 flex flex-wrap content-center">
      <div class="w-full">
        <NavigationFilterComponent :isMobile="true" />
      </div>
      <div class="w-full"><FiltersComponents :isMobile="true" /></div>
    </div>
  </div>
</template>

<style scoped>
.logo {
  background: url("../assets/logo-small.png");
}
</style>

<script>
// Vuex functions
import { mapGetters } from "vuex";

// Components
import UtilityComponent from "../components/base/UtilityComponent";
import NavigationFilterComponent from "../components/NavigationFilterComponent";
import FiltersComponents from "../components/FiltersComponent";

// Assets
import logo from "../assets/logo-small.png";

export default {
  components: {
    UtilityComponent,
    NavigationFilterComponent,
    FiltersComponents,
  },
  computed: {
    ...mapGetters(["getVideo"]),
  },
  data() {
    return {
      logo,
    };
  },
  methods: {
    goToHome() {
      const home = document.getElementById("nav-button-0");
      if (home) home.click();
      const currentRoute = this.$router.currentRoute.path;
      if (currentRoute !== "/") this.$router.push("/");
    },
  },
};
</script>
